import React, { useEffect, useState } from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { CALENDLY_URL, EMAIL_URL } from '../data/site';
const NAV = [{
  label: 'Assessment',
  href: '#assessment'
}, {
  label: 'Who it is for',
  href: '#audience'
}, {
  label: 'Background',
  href: '#background'
}, {
  label: 'Contact',
  href: EMAIL_URL
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-200 ease-editorial ${scrolled ? 'bg-navy/85 backdrop-blur-md border-b border-copper/30' : 'bg-navy/40 backdrop-blur-sm border-b border-transparent'}`} data-id="element-87" data-mp="31e1ru1i88eyj">
      <div className="mx-auto flex max-w-[1120px] items-center justify-between gap-6 px-5 py-3.5 sm:px-8" data-id="element-88" data-mp="2wkuor0melv9g">
        <a href="#top" className="flex min-w-0 flex-col" data-id="element-89" data-mp="2rm18j0fqfq5l">
          <span className="font-serif text-lg italic text-cream sm:text-xl" data-id="element-90" data-mp="2rkgf5e55md9b">Eric Blanvillain</span>
          <span className="font-sans text-[10px] uppercase tracking-label text-copper" data-id="element-91" data-mp="2mmx0id4jnygu">
            Data &amp; AI
          </span>
        </a>

        <nav aria-label="Primary" className="hidden flex-row items-center gap-6 whitespace-nowrap md:flex lg:gap-8" data-id="element-92" data-mp="3fbvkzgw53cpb">
          {NAV.map(item => <a key={item.href} href={item.href} className="font-sans text-[10px] uppercase tracking-[0.14em] text-cream/70 transition-colors duration-200 ease-editorial hover:text-cream" data-id="element-93" data-mp="35lj2rvbsrvmc">
              {item.label}
            </a>)}
        </nav>

        <a href={CALENDLY_URL} target="_blank" rel="noreferrer noopener" className="group inline-flex shrink-0 items-center gap-2 border border-copper bg-copper px-3 py-2.5 font-sans text-[10px] uppercase tracking-label text-navy transition-colors duration-200 ease-editorial hover:bg-transparent hover:text-copper sm:px-5" data-id="element-94" data-mp="3tbdda68n983f">
          Book 30 minutes
          <ArrowUpRightIcon className="h-3.5 w-3.5" data-id="element-95" data-mp="1mml6tbty8zx0" />
        </a>
      </div>
    </header>;
}